import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { preFixImgUrl } from '@/utils'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';


const Coupon = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeSwiper, setActiveSwiper] = useState(-1);

  const coverList = [
    {
      titleKey: 'aab335f1',
      subTitleKey: 'a981690f',
      icon: preFixImgUrl('ab80a0e50062a51921d99a064f086373.png'),
      iconBg: 'bg-[#FDF1EB]',
      textColor: 'text-[#FC844C]',
      items: [
        {
          tagBg: 'bg-[#FC844C]',
          bg: 'bg-[#FDF1EB]',
          titleKey: '21efbcfc',
          subTitleKey: 'b2b2aabb',
          img: preFixImgUrl('28461b4a8e19e967155dac8bbe2c8b09.png'),
        },
        {
          tagBg: 'bg-[#45C1FF]',
          bg: 'bg-[#EBF7FD]',
          titleKey: '201512ba',
          subTitleKey: 'ff6106dd',
          img: preFixImgUrl('87c9723e7eb1361403eb264b3da8fc01.png'),
        },
        {
          tagBg: 'bg-[#FFD569]',
          bg: 'bg-[#FDF8EB]',
          titleKey: '1a5dae72',
          subTitleKey: '6bc90dd3',
          img: preFixImgUrl('0b1f2e3d7cf08d5edfb6faa8f7761c98.png'),
        },
      ]
    }, {
      titleKey: '06186de7',
      subTitleKey: 'a981690f',
      icon: preFixImgUrl('5c03c959ba055ba5d697bfa587920ae1.png'),
      iconBg: 'bg-[#FDECEB]',
      textColor: 'text-[#FC504C]',
      items: [
        {
          tagBg: 'bg-[#9AC545]',
          bg: 'bg-[#EFFBD7]',
          titleKey: 'c5187a2a',
          subTitleKey: 'c1f84956',
          img: preFixImgUrl('16500191652dedfb9fb1257a1f7d5c92.png'),
        },
        {
          tagBg: 'bg-[#FFCD4E]',
          bg: 'bg-[#FDF8EB]',
          titleKey: '4f209cff',
          subTitleKey: '0a63ef0b',
          img: preFixImgUrl('e1d0589c565bdf0800f5d74584d8fc16.png'),
        },
        {
          tagBg: 'bg-[#FF7D7D]',
          bg: 'bg-[#FDEBEB]',
          titleKey: '51b7f9b5',
          subTitleKey: '220adbff',
          img: preFixImgUrl('40ba5ed994333d1300b252c4db95687d.png'),
        },
      ]
    }, {
      titleKey: '0bfa4ef9',
      subTitleKey: 'a981690f',
      icon: preFixImgUrl('0980b34957739b571345808663d5841f.png'),
      iconBg: 'bg-[#EBF2FD]',
      textColor: 'text-[#4C97FC]',
      items: [
        {
          tagBg: 'bg-[#45C1FF]',
          bg: 'bg-[#EBF7FD]',
          titleKey: '08e26a71',
          subTitleKey: '761158ff',
          img: preFixImgUrl('89f0786a5a0c12a94adaa0ba74e6817d.png'),
        },
        {
          tagBg: 'bg-[#21E1DA]',
          bg: 'bg-[#E2FFFE]',
          titleKey: 'c0934297',
          subTitleKey: '623702d2',
          img: preFixImgUrl('3924ce416d14a85e8bfa5842299b49c0.png'),
        },
      ]
    }, {
      titleKey: 'b7236d39',
      subTitleKey: '88ed1e06',
      icon: preFixImgUrl('38ad78afad0ff6ed8af08eee0264d0d6.png'),
      iconBg: 'bg-[#FDECEB]',
      textColor: 'text-[#FC504C]',
      items: [
        {
          tagBg: 'bg-[#9AC545]',
          bg: 'bg-[#EFFBD7]',
          titleKey: '372ecfa3',
          subTitleKey: '158b4c99',
          img: preFixImgUrl('e79ad0527c18b55688d5ccd363d85080.png'),
        },
        {
          tagBg: 'bg-[#FFCD4E]',
          bg: 'bg-[#FDF8EB]',
          titleKey: '120149b1',
          subTitleKey: 'cb4b7439',
          img: preFixImgUrl('a657af97ad33310d0599b83a9a823f10.png'),
        },
      ]
    }
  ]

  const featureList = [
    {
      icon: preFixImgUrl('a62e87d9b08d0ed91c68daf41016ca04.png'),
      titleKey: 'ad4da642',
      subTitleKey: 'a9d18187',
    },
    {
      icon: preFixImgUrl('e56f0cb3929e06947d9a9e1b48f5ee27.png'),
      titleKey: 'c38892aa',
      subTitleKey: '951b3f47',
    },
    {
      icon: preFixImgUrl('8a5e26505640eba9a3f72601c77df2e2.png'),
      titleKey: 'cb02ad09',
      subTitleKey: '0cfeff1c',
    },
    {
      icon: preFixImgUrl('010e6a29f1dd5dcb25fdbde1eeb16f83.png'),
      titleKey: 'c30e648e',
      subTitleKey: 'f1eb5226',
    },
  ]

  const howToUseList = [
    {
      img: preFixImgUrl('d5d4b41bcdbfa8734fae727d291ecbe0.png'),
      titleKey: '08fecd41',
    },
    {
      img: preFixImgUrl('d5d4b41bcdbfa8734fae727d291ecbe0.png'),
      titleKey: '6312b1de',
    },
    {
      img: preFixImgUrl('d5d4b41bcdbfa8734fae727d291ecbe0.png'),
      titleKey: '7d580b83',
    },
    {
      img: preFixImgUrl('d5d4b41bcdbfa8734fae727d291ecbe0.png'),
      titleKey: '4a4fbba1',
    },
  ]

  const merchantList = [
    {
      icon: preFixImgUrl('88ce07aba8e0848be2de7add0b066126.png'),
      titleKey: 'abe0975b',
      img: preFixImgUrl('2eabf975e5092c99f3b34f3dfb875729.png'),
      items: [
        '49b81bbe',
        'cf209b55',
        'WELCIA'
      ]
    },
    {
      icon: preFixImgUrl('1fe3150af104ec4a5a09b5aa4da9a1dd.png'),
      titleKey: 'd2328668',
      img: preFixImgUrl('fd01145507cc061c42b3bbb9e4c2bd67.png'),
      items: [
        '97b88552',
        '8c50976b',
        '8756ed9a'
      ]
    },
    {
      icon: preFixImgUrl('6561a3a191c5a2eff26e18987abc07ac.png'),
      titleKey: '788cc14c',
      img: preFixImgUrl('8482e6c894ca6285299c6e1cfe93c9ab.png'),
      items: [
        '3479ade5',
        'd410c2db',
        '4b83b2e8'
      ]
    },
  ]

  return (
    <div>
      <div className='w-full bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${preFixImgUrl('8116b4c9e1b7bd2129bfd74e23824249.png')})` }}>
        <div className='max-w-8xl mx-auto px-10 h-[800px] flex items-center'>
          <div className='bg-[#FFF8F0] rounded-[20px] w-full flex items-center justify-between p-15'>
            <div className='flex flex-col justify-center'>
              <div className='rounded-[12px] rounded-bl-[0] bg-[#FF9D34] w-fit h-[35px] leading-[35px]'>
                <LangText lngKey='1e9445e5' className='text-white text-[18px] px-3'>{t('1e9445e5')}</LangText>
              </div>
              <LangText lngKey='b87b1fe9' className='text-[44px] text-black mt-6'>{t('b87b1fe9')}</LangText>
              <LangText lngKey='81c8d3ea' className='text-[18px] text-[#666666] w-[540px] leading-[1.5] mt-5'>{t('81c8d3ea')}</LangText>
              <div className='flex gap-4 mt-6'>
                <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px]  w-fit text-[18px] bg-linear-to-r from-[#FD8A0F] to-[#FFA632] text-white cursor-pointer' onClick={()=> navigate('/coupon-list')}>
                  <LangText lngKey='913e4021'>{t('913e4021')}</LangText>
                </div>
                {/* <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px] outline outline-[#131313] w-fit text-[18px] hover:bg-linear-to-r from-[#FD8A0F] to-[#FFA632] hover:text-white hover:outline-none cursor-pointer'>
                  <LangText lngKey='34bae4cd'>{t('34bae4cd')}</LangText>
                </div> */}
              </div>
            </div>
            <div className='w-[485px] h-[362px] flex items-end justify-center bg-[#FFEFDC] rounded-[34px]'>
              <img src={preFixImgUrl('a548920b8b9a69c61ef37bb457af9df5.png')} className='w-[306px]' />
            </div>
          </div>
        </div>
      </div>
      {/* 覆盖吃住行购全方位 */}
      <div className='bg-[#F9FAFC]'>
        <div className='w-8xl mx-auto px-10 flex items-center flex-col py-[170px] pb-[162px]'>
          <LangText lngKey='581664d5' className='text-[36px] text-black font-bold text-center leading-[1.5]'>{t('581664d5')}</LangText>
          <LangText lngKey='7cd64af0' className='text-[24px] text-[#666666] mt-[33px] text-center leading-[1.5]'>{t('7cd64af0')}</LangText>
          <div className='w-full flex-wrap gap-[46px] mt-[110px] flex'>
            {
              coverList.map((item, index) => (
                <div key={index} className='w-[547px] bg-white flex flex-col items-start justify-start rounded-[30px] shadow-[0px_1px_40px_0px_rgba(224,226,228,0.8)] px-[33px] py-[30px] duration-300 hover:scale-110'>
                  <div className='flex items-center'>
                    <div className={`${item.iconBg} rounded-[14px] flex justify-center items-center w-[60px] h-[60px] mr-5`}>
                      <img src={item.icon} className='h-[30px]' />
                    </div>
                    <div className='flex flex-col'>
                      <LangText lngKey={item.titleKey} className='text-[28px] text-[#FC844C] font-bold'>{t(item.titleKey)}</LangText>
                      <LangText lngKey={item.subTitleKey} className='text-[20px] text-[#666666] mt-[9px]'>{t(item.subTitleKey)}</LangText>
                    </div>
                  </div>
                  <div className='flex flex-col gap-[18px] mt-[28px] w-full'>
                    {
                      item.items.map((subItem, index) => (
                        <div key={index} className={`${subItem.bg} flex justify-between items-center rounded-[10px] overflow-hidden pl-[80px] relative`}>
                          <div className={`${subItem.tagBg} absolute left-0 top-0  h-[32px] px-4 rounded-br-[26px]`}>
                            <LangText lngKey='6f500b9b' className='text-[18px] text-white leading-[32px]'>{t('6f500b9b')}</LangText>
                          </div>
                          <div className='flex flex-col'>
                            <LangText lngKey={subItem.titleKey} className='text-[24px] text-black font-bold'>{t(subItem.titleKey)}</LangText>
                            <LangText lngKey={subItem.subTitleKey} className='text-[20px] text-[#666666] mt-4'>{t(subItem.subTitleKey)}</LangText>
                          </div>
                          <img src={subItem.img} className='w-[187px] h-[104px]' />
                        </div>
                      ))
                    }
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
      {/* 核心功能 */}
      <div className='bg-white py-[140px]'>
        <div className='w-8xl mx-auto px-10 flex flex-col items-center'>
          <LangText lngKey='4a8aaeef' className='text-[36px] text-black font-bold'>{t('4a8aaeef')}</LangText>
          <div className='flex items-center justify-between mt-[107px] w-full'>
            {
              featureList.map(feature =>
                <div className='flex flex-col items-start max-w-[240px]' key={feature.titleKey}>
                  <img src={feature.icon} className='h-[40px]' />
                  <LangText lngKey={feature.titleKey} className='text-[26px] mt-6 text-black font-bold'>{t(feature.titleKey)}</LangText>
                  <LangText lngKey={feature.subTitleKey} className='text-[18px] text-[#666666] mt-4 leading-[1.5]'>{t(feature.subTitleKey)}</LangText>
                </div>
              )
            }
          </div>
          <div className='w-full h-[449px] bg-contain bg-center bg-no-repeat mt-[72px] relative flex items-center' style={{ backgroundImage: `url(${preFixImgUrl('2422d18dfd5c7a1f591d9a2cb75ecff2.png')})` }}>
            <div className='flex flex-col ml-[102px] max-w-[450px]'>
              <LangText lngKey='57fda304' className='text-[30px] text-white font-bold'>{t('57fda304')}</LangText>
              <div className='flex flex-col gap-7 mt-[36px]'>
                {
                  howToUseList.map((item, index) => (
                    <div
                      key={item.titleKey}
                      className='flex items-center'
                    // onClick={() => {
                    //   setActiveSwiper(index)
                    //   swiperRef.current?.slideToLoop(index)
                    // }}
                    >
                      <span className={classNames('w-3 h-3 rounded-[50%] mr-4 shrink-0', activeSwiper === index ? 'bg-[#1DF7FF]' : 'bg-white')}></span>
                      <LangText lngKey={item.titleKey} className='text-[18px] text-white leading-[1.5]'>{t(item.titleKey)}</LangText>
                    </div>
                  ))
                }
              </div>
            </div>

            <div className='w-[337px] absolute right-[148px] bottom-0'>
              <Swiper
                slidesPerView='auto'
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                loop
                modules={[Autoplay]}
              >
                 <SwiperSlide>
                      <img src={preFixImgUrl('a548920b8b9a69c61ef37bb457af9df5.png')} className='w-[337px] h-[418px]' />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img src={preFixImgUrl('d5d4b41bcdbfa8734fae727d291ecbe0.png')} className='w-[337px] h-[418px]' />
                    </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
      {/* 覆盖商户 */}
      <div className='bg-[#F9FAFC] py-[140px]'>
        <div className='w-8xl mx-auto px-10 flex flex-col items-center'>
          <LangText lngKey='c9c1c25b' className='text-[36px] text-black font-bold'>{t('c9c1c25b')}</LangText>
          <div className='flex w-full mt-[64px] justify-between'>
            {
              merchantList.map(item => (
                <div key={item.titleKey} className='w-[379px] rounded-[30px] overflow-hidden relative bg-white'>
                  <div className='bg-black absolute top-0 left-0 h-[54px] px-5 flex items-center rounded-br-[30px]'>
                    <div className='h-[34px] w-[34px] rounded-full bg-white flex items-center justify-center  mr-[10px]'>
                      <img src={item.icon} className='h-5' />
                    </div>
                    <LangText lngKey={item.titleKey} className='text-[26px] text-white font-bold'>{t(item.titleKey)}</LangText>
                  </div>
                  <img src={item.img} className='w-full h-[224px]' />
                  <div className='px-6 pt-7 pb-10 flex flex-col gap-6'>
                    {
                      item.items.map(subItem => (
                        <div key={subItem} className='flex items-center '>
                          <img src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} className='w-4 h-4 mr-[14px]' />
                          <LangText lngKey={subItem} className='text-[22px] text-[#666666]'>{t(subItem)}</LangText>
                        </div>
                      ))
                    }
                  </div>
                </div>
              ))
            }
          </div>
        </div>

      </div>
      {/* 为什么选择我们 */}
      <div className='bg-white py-[140px]'>
        <div className='w-8xl mx-auto px-10 flex flex-col items-center'>
          <LangText lngKey='1d53aff2' className='text-[36px] text-black font-bold mb-[54px]'>{t('1d53aff2')}</LangText>
          <div className='flex flex-col w-[900px]'>
            <div className='bg-[#FF9D34] w-[408px] text-center rounded-[24px] px-6 py-3 leading-[1.5] ml-[70px] relative'>
              <LangText lngKey='f58f747d' className='text-[20px] text-white font-bold'>{t('f58f747d')}</LangText>
              <svg width="70" height="50" xmlns="http://www.w3.org/2000/svg" className='absolute -left-[10px] bottom-0'>
                <g>
                  <path id="svg_2" d="m111,164" opacity="NaN" stroke="#000" fill="#fff" />
                  <path id="svg_3" d="m15,64.5" opacity="NaN" stroke-width="0" stroke="#000" fill="#ff9d34" />
                  <path id="svg_4" d="m38,63.5" opacity="NaN" stroke-width="0" stroke="#000" fill="#ff9d34" />
                  <path transform="rotate(-25.4897 32.9933 22.0647)" stroke="#000" id="svg_12" d="m53.63132,9.12391c-24.59622,20.423 -44.91483,21.49789 -59.88644,22.57278c-14.97161,1.07489 52.40063,20.423 69.51104,3.22468c17.11041,-17.19831 14.97161,-46.22046 -9.62461,-25.79747z" opacity="NaN" stroke-width="0" fill="#ff9d34" />
                </g>
              </svg>
            </div>
            <div className='bg-[#FF9D34] self-end w-[408px] text-center rounded-[24px] px-6 py-3 leading-[1.5] -mt-[16px] relative'>
              <LangText lngKey='5ee80b9a' className='text-[20px] text-white font-bold'>{t('5ee80b9a')}</LangText>
              <svg width="70" height="50" xmlns="http://www.w3.org/2000/svg" className='absolute -right-[10px] bottom-0 scale-x-[-1]'>
                <g>
                  <path id="svg_2" d="m111,164" opacity="NaN" stroke="#000" fill="#fff" />
                  <path id="svg_3" d="m15,64.5" opacity="NaN" stroke-width="0" stroke="#000" fill="#ff9d34" />
                  <path id="svg_4" d="m38,63.5" opacity="NaN" stroke-width="0" stroke="#000" fill="#ff9d34" />
                  <path transform="rotate(-25.4897 32.9933 22.0647)" stroke="#000" id="svg_12" d="m53.63132,9.12391c-24.59622,20.423 -44.91483,21.49789 -59.88644,22.57278c-14.97161,1.07489 52.40063,20.423 69.51104,3.22468c17.11041,-17.19831 14.97161,-46.22046 -9.62461,-25.79747z" opacity="NaN" stroke-width="0" fill="#ff9d34" />
                </g>

              </svg>
            </div>
            <div className='bg-[#FF9D34] w-[408px] text-center rounded-[24px] px-6 py-3 leading-[1.5] relative'>
              <LangText lngKey='d44dcaaa' className='text-[20px] text-white font-bold'>{t('d44dcaaa')}</LangText>
              <svg width="70" height="50" xmlns="http://www.w3.org/2000/svg" className='absolute -left-[10px] bottom-0 '>
                <g>
                  <path id="svg_2" d="m111,164" opacity="NaN" stroke="#000" fill="#fff" />
                  <path id="svg_3" d="m15,64.5" opacity="NaN" stroke-width="0" stroke="#000" fill="#ff9d34" />
                  <path id="svg_4" d="m38,63.5" opacity="NaN" stroke-width="0" stroke="#000" fill="#ff9d34" />
                  <path transform="rotate(-25.4897 32.9933 22.0647)" stroke="#000" id="svg_12" d="m53.63132,9.12391c-24.59622,20.423 -44.91483,21.49789 -59.88644,22.57278c-14.97161,1.07489 52.40063,20.423 69.51104,3.22468c17.11041,-17.19831 14.97161,-46.22046 -9.62461,-25.79747z" opacity="NaN" stroke-width="0" fill="#ff9d34" />
                </g>
              </svg>
            </div>
            <div className='bg-[#FF9D34] self-end w-[408px] text-center rounded-[24px] px-6 py-3 leading-[1.5] mr-[60px] -mt-[20px] relative'>
              <LangText lngKey='50e97293' className='text-[20px] text-white font-bold'>{t('50e97293')}</LangText>
              <svg width="70" height="50" xmlns="http://www.w3.org/2000/svg" className='absolute -right-[10px] bottom-0 scale-x-[-1]'>
                <g>
                  <path id="svg_2" d="m111,164" opacity="NaN" stroke="#000" fill="#fff" />
                  <path id="svg_3" d="m15,64.5" opacity="NaN" stroke-width="0" stroke="#000" fill="#ff9d34" />
                  <path id="svg_4" d="m38,63.5" opacity="NaN" stroke-width="0" stroke="#000" fill="#ff9d34" />
                  <path transform="rotate(-25.4897 32.9933 22.0647)" stroke="#000" id="svg_12" d="m53.63132,9.12391c-24.59622,20.423 -44.91483,21.49789 -59.88644,22.57278c-14.97161,1.07489 52.40063,20.423 69.51104,3.22468c17.11041,-17.19831 14.97161,-46.22046 -9.62461,-25.79747z" opacity="NaN" stroke-width="0" fill="#ff9d34" />
                </g>

              </svg>
            </div>
          </div>

        </div>
      </div>

      <div className='w-full h-[358px] bg-cover bg-center bg-no-repeat flex flex-col items-center' style={{ backgroundImage: `url(${preFixImgUrl('cc80f2d250131dcadd310f2a443b7a2c.png')})` }}>
        <LangText className='text-white text-[44px] mt-[66px]' lngKey='8ee3b212'>{t('8ee3b212')}</LangText>
        <LangText className='text-white text-[30px] mt-[30px] font-normal' lngKey='237aed2b'>{t('237aed2b')}</LangText>
        <div className='flex gap-[25px] mt-[60px]'>
          <div
            onClick={()=> navigate('/coupon-list')}
            className='h-[62px] text-white min-w-[231px] px-[44px] flex items-center justify-center rounded-[31px] outline w-fit text-[24px] bg-[#FF9D34] outline-none cursor-pointer'
          >
            <LangText lngKey='1a7f5e54'>{t('1a7f5e54')}</LangText>
          </div>
          <div
            className='h-[62px] text-white min-w-[231px] px-[44px] flex items-center justify-center rounded-[31px] outline w-fit text-[24px] cursor-pointer'
            onClick={() => navigate('/service-center')}
          >
            <LangText lngKey='ad839901'>{t('ad839901')}</LangText>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Coupon